import * as React from 'react';
import { Helmet } from 'react-helmet';

interface OpenGraphProps {
    siteName: string
    image: string | null
    title: string
    pageUrl: string
    imageHeight: string | null
    imageWidth: string | null
}

export const OpenGraph: React.FunctionComponent<OpenGraphProps> = ({ title, siteName, image, pageUrl, imageWidth, imageHeight }) => (
  <Helmet>
    <meta property="og:title" content={title} />
    <meta property="og:site_name" content={siteName} />
    {image ? <meta property="og:image" content={image} /> : null}
    <meta property="og:url" content={pageUrl} />
    {imageWidth ? <meta property="og:image:width" content={imageWidth} /> : null}
    {imageHeight ? <meta property="og:image:height" content={imageHeight} /> : null}
  </Helmet>
);
